// Stable application data API.
//
// Historical feature code imports `base44` from this module. The name is kept
// as a compatibility surface so existing functionality does not need to be
// rewritten when the backend changes. The implementation is selected by the
// backend adapter in src/backend/index.js.
import { backend } from '@/backend';

export const base44 = backend;
export default base44;
